import { ChangeDetectionStrategy, Component } from '@angular/core';
import { provideTranslocoScope, TranslocoDirective } from '@jsverse/transloco';
import { SdsIcon } from '@nieuwestroom/sds-icon';
import { NgpFocusVisible } from 'ng-primitives/interactions';

import { MetricId } from '@customer-portal/shared/analytics';

interface DownloadAppUsp {
  readonly titleKey: string;
  readonly descriptionKey: string;
}

@Component({
  selector: 'nscp-download-app-step',
  imports: [TranslocoDirective, SdsIcon, MetricId, NgpFocusVisible],
  templateUrl: './download-app-step.html',
  styleUrl: './download-app-step.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideTranslocoScope('onboarding')],
  host: { class: 'nscp-download-app-step' },
})
export class DownloadAppStep {
  protected readonly appStoreUrl = 'https://apps.apple.com/nl/app/nieuwestroom/id6758137598';
  protected readonly googlePlayUrl = 'https://play.google.com/store/apps/details?id=nl.nieuwestroom.platform.app&hl=nl&pli=1';

  protected readonly usps: readonly DownloadAppUsp[] = [
    { titleKey: 'onboarding.steps.downloadApp.usps.priceAlert.title', descriptionKey: 'onboarding.steps.downloadApp.usps.priceAlert.description' },
    { titleKey: 'onboarding.steps.downloadApp.usps.priceWarning.title', descriptionKey: 'onboarding.steps.downloadApp.usps.priceWarning.description' },
    { titleKey: 'onboarding.steps.downloadApp.usps.usageOnTheGo.title', descriptionKey: 'onboarding.steps.downloadApp.usps.usageOnTheGo.description' },
  ];
}
